import preparedReducer from './reducer';
import {
  requestSitesForVisit,
  requestVisitorsForVisit,
  createVisit,
  requestVisitorLogEvents,
  requestVisitorLogEvent,
  requestVisitorLogVisits,
  requestVisitorLogVisit,
} from './actions';
import _ from 'lodash';

export const reducer = preparedReducer;

export const SLICE_NAME = 'visitorLog';

export const selectors = (state) => state[SLICE_NAME];

export const selectSite = (state, siteID) => _.find(state[SLICE_NAME].sites, ['siteID', siteID]);

export const selectVisitor = (state, visitorID) =>
  _.find(state[SLICE_NAME].visitors, ['visitorID', visitorID]) || {};

export const selectVisitorLogEvent = (state, eventID) => state[SLICE_NAME].info[eventID];

export const selectVisitorLogVisit = (state, visitID) => state[SLICE_NAME].visitInfo[visitID];

export const actions = {
  createVisit,
  requestSitesForVisit,
  requestVisitorsForVisit,
  requestVisitorLogEvents,
  requestVisitorLogEvent,
  requestVisitorLogVisits,
  requestVisitorLogVisit,
};
